<template>
  <div class="expense-entry-form">
    <aside class="expense-entry-form__aside">
      <div class="expense-entry-form__aside-heading">
        <div class="expense-entry-form__aside-icon"><i class="fas fa-file-invoice"></i></div>
        <div><h3>Bukti transaksi</h3><p>Lampirkan foto kuitansi jika tersedia.</p></div>
      </div>
      <div class="expense-entry-form__preview">
        <div class="expense-entry-form__image-frame">
          <img
            class="expense-entry-form__proof-image"
            :src="[uploadedImageUrl == '' ? form.photo_name : uploadedImageUrl]"
            alt="Pratinjau bukti transaksi"
            @load="onImageLoad()"
          />
        </div>
      </div>
      <b-form-group id="input-group-image" class="expense-entry-form__upload">
        <label for="input-image">Unggah bukti <em class="text-muted">opsional</em></label>
        <clinical-file-upload v-model="form.photo" placeholder="Pilih gambar" drop-placeholder="Lepaskan file di sini" @change="onFileUpload"></clinical-file-upload>
        <small class="text-danger">{{ error.photo }}</small>
      </b-form-group>
      <div class="expense-entry-form__secure"><i class="fas fa-shield-alt"></i><span>Dokumen tersimpan bersama data transaksi.</span></div>
    </aside>

    <section class="expense-entry-form__content">
      <div class="expense-entry-form__section-heading">
        <div class="expense-entry-form__section-icon"><i class="fas fa-wallet"></i></div>
        <div><h3>Informasi pengeluaran</h3><p>Lengkapi detail transaksi sebelum disimpan.</p></div>
      </div>
      <b-form class="expense-entry-form__fields" @submit.stop.prevent="formOnSubmit" enctype="multipart/form-data">
        <!-- Input Flow Type -->
        <b-form-group
          class="expense-entry-form__field"
          id="input-group-flow-type"
          label="Jenis Keuangan:"
          label-for="input-flow-type"
        >
          <b-form-select
            id="input-flow-type"
            v-model="form.flow_type"
            :options="flowTypes"
          ></b-form-select>
        </b-form-group>

        <!-- Input Modal Trigger -->
        <b-form-group id="input-group-trigger-modal-expense-category" class="expense-entry-form__field">
          <label for="input-trigger-modal-expense-category"
            >Kategori Pengeluaran: <em class="text-muted">opsional</em></label
          >
          <b-form-input
            id="input-trigger-modal-expense-category"
            v-model="display.expense_category_name"
            placeholder="Pilih Kategori"
            :readonly="
              form.flow_type == 2 ? false : form.flow_type == 1 ? true : true
            "
            :class="
              form.flow_type == 2 ? 'disabled' : form.flow_type == 1 ? '' : ''
            "
            :disabled="
              form.flow_type == 2 ? true : form.flow_type == 1 ? false : false
            "
            @click="$bvModal.show('modal-expense-category')"
          >
          </b-form-input>
          <small class="text-danger">{{ error.expense_category_id }}</small>
        </b-form-group>

        <!-- Input Date -->
        <!-- <b-form-group
          id="input-group-date"
          label="Tanggal:"
          label-for="input-date"
        >
          <b-form-datepicker
            v-model="form.date"
            id="input-date"
            placeholder="Tanggal"
            locale="id"
          ></b-form-datepicker>
          <small class="text-danger">{{ error.date }}</small>
        </b-form-group> -->

        <b-form-group
          class="expense-entry-form__field"
          id="input-group-date"
          label="Tanggal:"
          label-for="input-date"
        >
          <b-input-group>
            <b-input-group-prepend>
              <b-form-datepicker
                locale="id"
                placeholder="Tanggal"
                id="input-date"
                v-model="form.date"
                button-only
                aria-controls="example-input"
              ></b-form-datepicker>
            </b-input-group-prepend>
            <b-form-input
              id="input-date"
              v-model="form.date"
              type="text"
              placeholder="YYYY-MM-DD"
              @input="formaterDate"
            ></b-form-input>
          </b-input-group>
          <small class="text-danger">{{ error.date }}</small>
        </b-form-group>

        <!-- Input Name -->
        <b-form-group
          class="expense-entry-form__field"
          id="input-group-name"
          label="Keterangan:"
          label-for="input-name"
        >
          <b-form-input
            id="input-name"
            v-model="form.name"
            placeholder="Keterangan"
          ></b-form-input>
          <small class="text-danger">{{ error.name }}</small>
        </b-form-group>

        <!-- Input Amount -->
        <b-form-group
          class="expense-entry-form__field"
          id="input-group-amount"
          label="Jumlah:"
          label-for="input-amount"
          v-if="type == 'add'"
        >
          <b-form-input
            id="input-amount"
            v-model="formatedAmount"
            inputmode="numeric"
            placeholder="Jumlah"
          ></b-form-input>
          <small class="text-danger">{{ error.amount }}</small>
        </b-form-group>

        <!-- Input payment type -->
        <b-form-group
          class="expense-entry-form__field"
          id="input-group-flow-type"
          label="Metode Pengeluaran:"
          label-for="input-flow-type"
        >
          <b-form-select
            id="input-flow-type"
            v-model="form.expense_method_type"
            :options="selectMethod"
            @change="setMethod"
          ></b-form-select>
        </b-form-group>

        <!-- Input payment type transfer -->
        <b-form-group
          class="expense-entry-form__field"
          id="input-group-flow-type"
          label="Rekening:"
          label-for="input-flow-type"
          v-if="isTransfer"
        >
          <b-form-select
            id="input-flow-type"
            v-model="form.expense_method"
            :options="selectTransfer"
          ></b-form-select>
        </b-form-group>

        <!-- Input Note -->
        <b-form-group id="input-group-notes" class="expense-entry-form__field expense-entry-form__field--wide">
          <label for="input-notes"
            >Catatan: <em class="text-muted">opsional</em></label
          >
          <b-form-textarea
            id="input-notes"
            v-model="form.notes"
            placeholder="Catatan"
            rows="4"
            max-rows="8"
          ></b-form-textarea>
          <small class="text-danger">{{ error.notes }}</small>
        </b-form-group>

        <!-- Button -->
        <div class="expense-entry-form__actions">
        <b-button type="submit" variant="primary"><i class="fas fa-save mr-2"></i>Simpan pengeluaran</b-button>
        <b-button
          class="ml-2"
          variant="default"
          @click="$router.push('/expense/list')"
        >
          <i class="fas fa-arrow-left mr-2"></i>Kembali
        </b-button>
        </div>
      </b-form>
    </section>

    <ModalExpenseCategory
      @chosenCategory="setCategory"
      @submitedCategory="setCategory"
    />
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import ModalExpenseCategory from "@/component/general/ModalExpenseCategory.vue";

export default {
  props: {
    form: Object,
    route: String,
    type: String,
    
  },

  components: {
    ModalExpenseCategory,
  },

  data() {
    return {
      // Display Data
      display: {
        expense_category_name: "",
      },
      // Error
      error: {
        photo: "",
        date: "",
        name: "",
        amount: "",
        expense_category_id: "",
        notes: "",
      },
      // Options
      flowTypes: [
        { text: "Pengeluaran", value: 1 },
        { text: "Deposit", value: 2 },
      ],
      selectMethod: [
        { text: "Cash", value: 1 },
        { text: "Transfer", value: 2 },
      ],
      // payment method
      selectTransfer: [],
      isTransfer: false,
      // Others
      imgLoaded: false,
      uploadedImageUrl: "",
    };
  },

  computed: {
    formatedAmount: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.amount = newValue.toLocaleString("id-ID");
        } else {
          this.form.amount = "";
        }
      },
      get() {
        return this.form.amount;
      },
    },
  },

  methods: {
     formaterDate(val) {
      if (val.length == 4) {
        this.form.date = this.form.date + "-";
      }
      if (val.length == 7) {
        this.form.date = this.form.date + "-";
      }
    },

    onImageLoad() {
      this.imgLoaded = true;
    },

    onFileUpload(evt) {
      this.uploadedImageUrl = URL.createObjectURL(evt.target.files[0]);
      this.form.photo = evt.target.files[0];
    },

    async setMethod() {
      if (this.form.expense_method_type == 2) {
        // this.form.expense_method = 1
        this.isTransfer = true;
      } else {
        this.form.expense_method = 0;
        this.isTransfer = false;
      }
    },

    async getMethod() {
      let response = await module.setSelectOption("bank-accounts");
      this.selectTransfer = response.data;
      // console.log("==================== res ===============",response);
    },

    async formOnSubmit() {
      if (this.isTransfer == false) {
        this.form.expense_method = 0;
      }
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
      }
      let response = await module.submit(formData, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/expense/list");
      }
    },

    setCategory(value) {
      this.form.expense_category_id = value.id;
      this.display.expense_category_name = value.name;
      this.$bvModal.hide("modal-expense-category");
    },
  },

  watch: {
    "form.expense_category_name": function (newVal, oldVal) {
      this.display.expense_category_name = newVal;
    },
  },

  mounted() {
    this.getMethod();
  },
};
</script>

<style lang="scss">
.expense-entry-form__proof-image {
  display: block;
  position: static !important;
  inset: auto !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin: 0 !important;
  object-fit: contain !important;
  transform: none !important;
}
</style>
